import { Store, DataFactory } from 'n3';
import { parseTurtle, serializeTurtle, RDF, NOTIFY, getOneMatchingQuad } from '@janeirodigital/interop-utils';
import { DiscoveryClient } from '@solid-notifications/discovery';

function buildChannel(topic, channelType, sendTo) {
    const channel = new Store();
    const subject = DataFactory.blankNode();
    channel.add(DataFactory.quad(subject, RDF.type, DataFactory.namedNode(channelType)));
    channel.add(DataFactory.quad(subject, NOTIFY.topic, DataFactory.namedNode(topic)));
    if (sendTo) {
        channel.add(DataFactory.quad(subject, NOTIFY.sendTo, DataFactory.namedNode(sendTo)));
    }
    return channel;
}
function formatChannel(dataset) {
    const subject = getOneMatchingQuad(dataset, null, RDF.type).subject;
    const channel = {
        id: subject.value,
        type: getOneMatchingQuad(dataset, subject, RDF.type).object.value,
        topic: getOneMatchingQuad(dataset, subject, NOTIFY.topic).object.value,
    };
    const receiveFrom = getOneMatchingQuad(dataset, subject, NOTIFY.receiveFrom)?.object.value;
    if (receiveFrom)
        channel.receiveFrom = receiveFrom;
    const sendTo = getOneMatchingQuad(dataset, subject, NOTIFY.sendTo)?.object.value;
    if (sendTo)
        channel.sendTo = sendTo;
    return channel;
}
class SubscriptionClient {
    constructor(authnFetch) {
        this.authnFetch = authnFetch;
        this.discovery = new DiscoveryClient(this.authnFetch);
        this.rdf = {
            contentType: 'text/turtle',
            parse: parseTurtle,
            serialize: serializeTurtle
        };
    }
    async subscribe(topic, channelType, sendTo) {
        const service = await this.discovery.findService(topic, channelType);
        if (!service) {
            throw Error(`Discovery did not succeed: channel type ${channelType} is not supported by the Solid Server.`);
        }
        const requestedChannel = buildChannel(topic, channelType, sendTo);
        const response = await this.authnFetch(service.id, {
            method: 'POST',
            body: await this.rdf.serialize(requestedChannel),
            headers: {
                'Accept': this.rdf.contentType,
                'Content-Type': this.rdf.contentType
            }
        });
        if (!response.headers.get('Content-Type').startsWith(this.rdf.contentType)) {
            throw new Error('unexpected Content Type');
        }
        const dataset = await this.rdf.parse(await response.text(), response.url);
        return formatChannel(dataset);
    }
}

export { SubscriptionClient };
//# sourceMappingURL=index.mjs.map
